/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react/index.js'
import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'

const FormElectricAutonomy = ({
  label,
  name,
  onChange,
  options,
  overlayContentRef,
  type,
  value,
  withLabel = true,
  wrapper
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const {DEFAULT_ELECTRIC_AUTONOMY_SEARCH} = config.get('searchFilters')

  const optionsMapping = useMemo(
    () =>
      options.map(option => ({
        id: option,
        label: `${option} ${i18n.t('COMMON.UNIT_KMS').toLowerCase()}`
      })),
    [options]
  )

  const handleChange = ({value: filterItemValue}) => {
    const [currentValue] = filterItemValue.filter(id => id !== allSelectionsId)

    onChange(null, {
      field: name,
      lastFilter: TRACKING_FILTER_NAMES[name].FROM,
      value: {...value, from: currentValue}
    })
  }

  const handleReset = ({filters}) => {
    const [filterName] = filters
    onChange(null, {
      field: name,
      value: {...value, [filterName]: DEFAULT_ELECTRIC_AUTONOMY_SEARCH[filterName]}
    })
  }

  const placeholder = value.from
    ? `${i18n.t('COMMON_FROM')} ${value.from} ${i18n.t('COMMON.UNIT_KMS').toLowerCase()}`
    : i18n.t('COMMON_FROM')

  return (
    <FilterWrapperBasic
      description={htmlStringToReactElement(i18n.t('FILTERS.ELECTRIC_AUTONOMY.DESCRIPTION', {brkLine: `<br/>`}))}
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON_FROM'),
          label: i18n.t(label),
          name: 'from',
          options: optionsMapping,
          type
        }
      ]}
      group={`${name}Group`}
      legend={i18n.t(label)}
      onChange={handleChange}
      onReset={handleReset}
      overlayContentRef={overlayContentRef}
      placeholder={placeholder}
      showLegend={withLabel}
      value={{from: [value.from || allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormElectricAutonomy.displayName = 'FormElectricAutonomy'
FormElectricAutonomy.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.object,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormElectricAutonomy
